import React, { useContext, useEffect, useState } from "react";
import moment from "moment";
import { FootballAPIContext } from "../../contexts/FootballAPIContext";
import FolderItem from "../Show/FolderItem";
import styled from "styled-components";
import { Button, ScrollBar } from "../../Theme/Hyper";
import BasicPack from "../../FootballGraphics/BasicPack/Graphics";
import { ControlContext } from "../../contexts/ControlContext";
import { ProjectContext } from "../../contexts/ProjectContext";

const GameList = styled(ScrollBar)`
  display: flex;
  flex-direction: column;
  border-right: 1px solid #2e3a50;
  width: 70%;
  min-height: 100%;
`;
const Row = styled.div`
  display: flex;
`;
const Content = styled(ScrollBar)`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 172px);

  overflow-y: auto;
  width: 100%;
  overflow-x: hidden;
`;

const TableHeader = styled.div`
  display: flex;
  font-weight: 100;
  background-color: #252e40;

  div {
    padding: 0.5em;
    border-left: 1px solid black;
    font-size: 0.8em;
    :first-child {
      width: 40px;
      display: flex;
      justify-content: center;
    }
    :nth-child(2) {
      width: 60px;
      display: flex;
    }
    :nth-child(3) {
      width: 320px;
      display: flex;
    }
    :nth-child(4) {
      width: 80px;
      display: flex;
    }
  }
`;
const TableBody = styled.div`
  display: flex;
  flex-direction: column;
`;
const TableRow = styled.div`
  display: flex;
  align-items: center;
  height: 25px;
  white-space: pre;
  opacity: ${(props) => (props.available === 1 ? 1 : 0.7)};
  :nth-of-type(even) {
    background-color: #1c222b;
  }
  :hover {
    background-color: #d11e42;
  }
  div {
    height: 25px;
    padding: 0.5em;
    padding-left: 10px;
    border-left: 1px solid black;
    font-size: 0.7em;
    align-items: center;
    display: flex;
  }
`;
const PageNameDiv = styled.div`
  overflow: hidden;
  max-width: 250px;
`;
const TemplateNameDiv = styled.div`
  overflow: hidden;
`;
const EngineNameDiv = styled.div`
  overflow: hidden;
  display: flex;
  color: #8b8b8b;
`;
const DateRow = styled.div`
  display: flex;
  justify-content: space-evenly;
`;
const DateButton = styled(Button)`
  margin-right: 5px;
  cursor: pointer;
  :hover {
    background-color: #d20a3e;
  }
`;

function FootballData() {
  const {
    getFixtures,
    getFixture,
    getManager,
    getStandings,
    getOPTAEvents,
    getFixturesByDateRange,
  } = useContext(FootballAPIContext);
  const { scenes } = useContext(ProjectContext);
  const [fixtures, setFixtures] = useState([]);
  const [selectedGame, setSelectedGame] = useState();
  const [selectedCompetition, setSelectedCompetition] = useState();
  const [selectedView, setSelectedView] = useState();
  const [graphics, setGraphics] = useState();
  const [game, setGame] = useState();
  const [homeManager, setHomeManager] = useState();
  const [awayManager, setAwayManager] = useState();
  const [standings, setStandings] = useState();
  const [optaEvents, setOPTAEvents] = useState();
  const [fixturesData, setFixturesData] = useState();
  const [optaEventGraphics, setOPTAEventGraphics] = useState();
  const [date, setDate] = useState(moment().format("YYYY-MM-DD"));
  const {
    previewFootball,
    animate,
    update,
    triggerAnimation,
    clearPreview,
    animateOff,
  } = useContext(ControlContext);
  useEffect(() => {
    setGraphics(
      BasicPack({
        preview: previewFootball,
        animate,
        update,
        animateOff,
        triggerAnimation,
        clearPreview,
      })
    );
  }, []);

  useEffect(() => {
    getFixtures({ date: date + "Z" }).then((data) => {
      setFixtures(
        JSON.parse(JSON.stringify(data ?? []))?.sort((a, b) => {
          return a?.competition?.order - b?.competition?.order;
        })
      );
    });
  }, [date]);

  useEffect(() => {
    if (selectedGame) {
      getFixture({ fixtureId: selectedGame?._id }).then((data) => {
        setGame(data);
        getManager({
          teamId: data?.home_team?._id,
          seasonId: data?.season?._id,
        }).then((data) => {
          setHomeManager(data);
        });
        getManager({
          teamId: data?.away_team?._id,
          seasonId: data?.season?._id,
        }).then((data) => {
          setAwayManager(data);
        });
        getStandings({
          season: data?.season?._id,
          date: data.date?.replace("Z", ""),
        }).then((data) => {
          setStandings(data);
        });
        getOPTAEvents({
          gameId: data?._id,
        }).then((data) => {
          setOPTAEvents(data);
        });
        getFixturesByDateRange({
          start_date:
            moment(data.date).startOf("isoWeek")?.format("YYYY-MM-DD") + "Z",
          end_date:
            moment(data.date).endOf("isoWeek")?.format("YYYY-MM-DD") + "Z",
          competition: data?.competition?._id,
        }).then((fixtures) => {
          fixtures = fixtures?.filter(
            (f) => f?.competition?._id === data?.competition?._id
          );
          fixtures = fixtures.map((fix) => {
            return {
              ...fix,
              home_scorers: new Array(fix.opta_scores?.total?.home ?? 0),
              away_scorers: new Array(fix.opta_scores?.total?.away ?? 0),
            };
          });
          setFixturesData(fixtures);
        });
      });
    }
  }, [selectedGame]);

  useEffect(() => {
    if (optaEvents && graphics) {
      let optaGraphics = [];
      let filteredEvents = optaEvents
        ?.filter((e) => {
          return (
            e?.typeId === 16 ||
            e?.typeId === 17 ||
            e?.typeId === 18 ||
            (e?.typeId === 30 &&
              game?.home_team?.opta_ID === e.contestantId &&
              e.qualifier.find((item) => item.qualifierId === 57)?.value ===
                "0")
          );
        })
        ?.sort((a, b) => {
          if (a.periodId > b.periodId) {
            return 1;
          } else if (a.periodId < b.periodId) {
            return -1;
          }
          if (a.timeMin > b.timeMin) {
            return 1;
          } else if (a.timeMin < b.timeMin) {
            return -1;
          }
          if (a.timeSec > b.timeSec) {
            return 1;
          } else if (a.timeSec < b.timeSec) {
            return -1;
          }
          return 0;
        });

      for (let x = 0; x < filteredEvents?.length; x++) {
        let e = filteredEvents?.[x];

        let player = game?.lineup?.home?.find(
          (p) => p.squad?.player?.opta_ID === e.playerId
        );
        if (!player) {
          player = game?.lineup?.away?.find(
            (p) => p.squad?.player?.opta_ID === e.playerId
          );
        }
        let team =
          game?.home_team?.opta_ID === e.contestantId
            ? game?.home_team
            : game?.away_team;

        switch (e.typeId) {
          case 16:
            let goal = {
              own_goal:
                e.qualifier?.find((q) => q.qualifierId === 28) !== undefined,
              penalty:
                e.qualifier?.find((q) => q.qualifierId === 9) !== undefined,
            };

            let home_score = filteredEvents?.filter(
              (ev, index) =>
                index <= x &&
                ev?.typeId === 16 &&
                ((ev?.contestantId === game?.home_team?.opta_ID &&
                  ev.qualifier.find((item) => item.qualifierId === 28) ===
                    undefined) ||
                  (ev?.contestantId === game?.away_team?.opta_ID &&
                    ev.qualifier.find((item) => item.qualifierId === 28) !==
                      undefined))
            );

            let away_score = filteredEvents?.filter(
              (ev, index) =>
                index <= x &&
                ev?.typeId === 16 &&
                ((ev?.contestantId === game?.away_team?.opta_ID &&
                  ev.qualifier.find((item) => item.qualifierId === 28) ===
                    undefined) ||
                  (ev?.contestantId === game?.home_team?.opta_ID &&
                    ev.qualifier.find((item) => item.qualifierId === 28) !==
                      undefined))
            );

            optaGraphics.push({
              name:
                e?.timeMin?.toString()?.padStart(2, "0") +
                ":" +
                e.timeSec?.toString()?.padStart(2, "0") +
                " " +
                team?.code +
                " - " +
                (player?.squad?.shirt_number ??
                  player?.squad?.opta_shirt_number) +
                " - " +
                (player?.squad?.player?.first_name ??
                  player?.squad?.player?.opta_first_name) +
                " " +
                (player?.squad?.player?.last_name ??
                  player?.squad?.player?.opta_last_name) +
                " - " +
                (goal?.own_goal
                  ? "Own Goal"
                  : goal?.penalty
                  ? "Penalty"
                  : "Goal"),
              graphic: graphics?.find((g) => g.name === "PlayerScored"),
              options: {
                goal: goal,
                player: {
                  shirt_number:
                    player?.squad?.shirt_number ??
                    player?.squad?.opta_shirt_number,
                  ...player?.squad?.player,
                },
                game_time:
                  e?.timeMin?.toString()?.padStart(2, "0") +
                  ":" +
                  e?.timeSec?.toString()?.padEnd(2, "0"),
                team: team,
                game,
              },
            });
            optaGraphics.push({
              name:
                e?.timeMin?.toString()?.padStart(2, "0") +
                ":" +
                e.timeSec?.toString()?.padStart(2, "0") +
                " " +
                game?.home_team?.code +
                " " +
                home_score?.length +
                " - " +
                game?.away_team?.code +
                " " +
                away_score?.length +
                " - Score Update",
              graphic: graphics?.find((g) => g.name === "Score"),
              options: {
                game: {
                  ...game,
                  home_scorers: filteredEvents?.filter(
                    (ev, index) =>
                      x >= index &&
                      ev?.typeId === 16 &&
                      ((ev?.contestantId === game?.home_team?.opta_ID &&
                        ev.qualifier.find((item) => item.qualifierId === 28) ===
                          undefined) ||
                        (ev?.contestantId === game?.away_team?.opta_ID &&
                          ev.qualifier.find(
                            (item) => item.qualifierId === 28
                          ) !== undefined))
                  ),
                  away_scorers: filteredEvents?.filter(
                    (ev, index) =>
                      x >= index &&
                      ev?.typeId === 16 &&
                      ((ev?.contestantId === game?.away_team?.opta_ID &&
                        ev.qualifier.find((item) => item.qualifierId === 28) ===
                          undefined) ||
                        (ev?.contestantId === game?.home_team?.opta_ID &&
                          ev.qualifier.find(
                            (item) => item.qualifierId === 28
                          ) !== undefined))
                  ),
                },
                optaEvents: filteredEvents?.filter(
                  (ev, index) => x >= index && ev?.typeId === 16
                ),
              },
            });
            optaGraphics.push({
              name:
                e?.timeMin?.toString()?.padStart(2, "0") +
                ":" +
                e.timeSec?.toString()?.padStart(2, "0") +
                " " +
                game?.home_team?.code +
                " " +
                home_score?.length +
                " - " +
                game?.away_team?.code +
                " " +
                away_score?.length +
                " - Clock",
              graphic: graphics?.find((g) => g.name === "CLOCK"),
              options: {
                game: {
                  ...game,
                  home_scorers: filteredEvents?.filter(
                    (ev, index) =>
                      x >= index &&
                      ev?.typeId === 16 &&
                      ((ev?.contestantId === game?.home_team?.opta_ID &&
                        ev.qualifier.find((item) => item.qualifierId === 28) ===
                          undefined) ||
                        (ev?.contestantId === game?.away_team?.opta_ID &&
                          ev.qualifier.find(
                            (item) => item.qualifierId === 28
                          ) !== undefined))
                  ),
                  away_scorers: filteredEvents?.filter(
                    (ev, index) =>
                      x >= index &&
                      ev?.typeId === 16 &&
                      ((ev?.contestantId === game?.away_team?.opta_ID &&
                        ev.qualifier.find((item) => item.qualifierId === 28) ===
                          undefined) ||
                        (ev?.contestantId === game?.home_team?.opta_ID &&
                          ev.qualifier.find(
                            (item) => item.qualifierId === 28
                          ) !== undefined))
                  ),
                },
              },
            });
            break;
          case 17:
            let redCard =
              e.qualifier.find((item) => item.qualifierId === 33) !== undefined;
            let yellowCard =
              e.qualifier.find((item) => item.qualifierId === 31) !== undefined;
            let doubleYellow =
              e.qualifier.find((item) => item.qualifierId === 32) !== undefined;
            let type = "";
            if (redCard) {
              type = 3;
            }
            if (yellowCard) {
              type = 1;
            }
            if (doubleYellow) {
              type = 2;
            }

            optaGraphics.push({
              name:
                e?.timeMin?.toString()?.padStart(2, "0") +
                ":" +
                e.timeSec?.toString()?.padStart(2, "0") +
                " " +
                team?.code +
                " - " +
                (player?.squad?.shirt_number ??
                  player?.squad?.opta_shirt_number) +
                " - " +
                (player?.squad?.player?.first_name ??
                  player?.squad?.player?.opta_first_name) +
                " " +
                (player?.squad?.player?.last_name ??
                  player?.squad?.player?.opta_last_name) +
                " - " +
                (type === 1
                  ? "Yellow Card"
                  : type === 2
                  ? "Double Yellow Card"
                  : type === 3
                  ? "Red Card"
                  : ""),
              graphic: graphics?.find((g) => g.name === "Card"),
              options: {
                game,
                team,
                player: {
                  ...player?.squad,
                  ...player?.squad?.player,
                },
                cardType: type,
              },
            });
            break;
          case 18:
            let playerOn = optaEvents.find((i) => {
              return (
                i.contestantId === e?.contestantId &&
                i.eventId ===
                  parseInt(
                    e.qualifier?.find((q) => q.qualifierId === 55)?.value
                  )
              );
            });
            let player_on = game?.lineup?.home?.find(
              (p) => p.squad?.player?.opta_ID === playerOn?.playerId
            );

            if (!player_on) {
              player_on = game?.lineup?.away?.find(
                (p) => p.squad?.player?.opta_ID === playerOn?.playerId
              );
            }

            optaGraphics.push({
              name:
                e?.timeMin?.toString()?.padStart(2, "0") +
                ":" +
                e.timeSec?.toString()?.padStart(2, "0") +
                " " +
                team?.code +
                " ON: " +
                (player_on?.squad?.player?.last_name ??
                  player_on?.squad?.player?.opta_last_name) +
                " OFF: " +
                " - " +
                (player?.squad?.player?.last_name ??
                  player?.squad?.player?.opta_last_name) +
                " - LT Substitute",
              graphic: graphics?.find((g) => g.name === "Substitution"),
              options: {
                players: [player_on, player],
                game: {
                  ...game,
                },
                team,
              },
            });

            optaGraphics.push({
              name:
                e?.timeMin?.toString()?.padStart(2, "0") +
                ":" +
                e.timeSec?.toString()?.padStart(2, "0") +
                " " +
                team?.code +
                " ON: " +
                (player_on?.squad?.player?.last_name ??
                  player_on?.squad?.player?.opta_last_name) +
                " OFF: " +
                " - " +
                (player?.squad?.player?.last_name ??
                  player?.squad?.player?.opta_last_name) +
                " - Clock Substitute",
              graphic: graphics?.find((g) => g.name === "Substitution"),
              options: {
                players: [player_on, player],
                game: {
                  ...game,
                },
                team,
                clock: true,
              },
            });

            let all_subs = optaEvents.filter(
              (ev) =>
                ev.timeMin >= e.timeMin - 1 &&
                ev.timeMin <= e.timeMin &&
                ev.eventId <= e.eventId &&
                ev.contestantId === e.contestantId &&
                ev.typeId === 18
            );
            if (all_subs.length === 2) {
              let players_on = [];
              let players_off = [];
              for (let x = 0; x < all_subs.length; x++) {
                let sub_event = all_subs[x];
                let player_on_id = optaEvents.find((i) => {
                  return (
                    i.contestantId === e?.contestantId &&
                    i.eventId ===
                      parseInt(
                        sub_event.qualifier?.find((q) => q.qualifierId === 55)
                          ?.value
                      )
                  );
                })?.playerId;

                let player_on = game?.lineup?.home?.find(
                  (p) => p?.squad?.player?.opta_ID === player_on_id
                );
                if (player_on === undefined) {
                  player_on = game?.lineup?.away?.find(
                    (p) => p?.squad?.player?.opta_ID === player_on_id
                  );
                }
                players_on.push(player_on);
                let player_off = game?.lineup?.home?.find(
                  (p) => p?.squad?.player?.opta_ID === sub_event.playerId
                );
                if (player_off === undefined) {
                  player_off = game?.lineup?.away?.find(
                    (p) => p?.squad?.player?.opta_ID === sub_event.playerId
                  );
                }
                players_off.push(player_off);
              }
              optaGraphics.push({
                name:
                  e?.timeMin?.toString()?.padStart(2, "0") +
                  ":" +
                  e.timeSec?.toString()?.padStart(2, "0") +
                  " " +
                  team?.code +
                  " - LT Double Substitute",
                graphic: graphics?.find((g) => g.name === "TwoSubstitution"),
                options: {
                  players_on,
                  players_off,
                  game: {
                    ...game,
                  },
                  team,
                },
              });
            }
            if (all_subs.length === 3) {
              let players_on = [];
              let players_off = [];
              for (let x = 0; x < all_subs.length; x++) {
                let sub_event = all_subs[x];
                let player_on_id = optaEvents.find((i) => {
                  return (
                    i.contestantId === e?.contestantId &&
                    i.eventId ===
                      parseInt(
                        sub_event.qualifier?.find((q) => q.qualifierId === 55)
                          ?.value
                      )
                  );
                })?.playerId;

                let player_on = game?.lineup?.home?.find(
                  (p) => p?.squad?.player?.opta_ID === player_on_id
                );
                if (player_on === undefined) {
                  player_on = game?.lineup?.away?.find(
                    (p) => p?.squad?.player?.opta_ID === player_on_id
                  );
                }
                players_on.push(player_on);
                let player_off = game?.lineup?.home?.find(
                  (p) => p?.squad?.player?.opta_ID === sub_event.playerId
                );
                if (player_off === undefined) {
                  player_off = game?.lineup?.away?.find(
                    (p) => p?.squad?.player?.opta_ID === sub_event.playerId
                  );
                }
                players_off.push(player_off);
              }
              optaGraphics.push({
                name:
                  e?.timeMin?.toString()?.padStart(2, "0") +
                  ":" +
                  e.timeSec?.toString()?.padStart(2, "0") +
                  " " +
                  team?.code +
                  " - LT Triple Substitute",
                graphic: graphics?.find((g) => g.name === "ThreeSubstitution"),
                options: {
                  players_on,
                  players_off,
                  game: {
                    ...game,
                  },
                  team,
                },
              });
            }
            break;
          case 30:
            let home_score_ft = filteredEvents?.filter(
              (ev) =>
                e.periodId >= ev.periodId &&
                ev?.typeId === 16 &&
                ((ev?.contestantId === game?.home_team?.opta_ID &&
                  ev.qualifier.find((item) => item.qualifierId === 28) ===
                    undefined) ||
                  (ev?.contestantId === game?.away_team?.opta_ID &&
                    ev.qualifier.find((item) => item.qualifierId === 28) !==
                      undefined))
            );

            let away_score_ft = filteredEvents?.filter(
              (ev) =>
                e.periodId >= ev.periodId &&
                ev?.typeId === 16 &&
                ((ev?.contestantId === game?.away_team?.opta_ID &&
                  ev.qualifier.find((item) => item.qualifierId === 28) ===
                    undefined) ||
                  (ev?.contestantId === game?.home_team?.opta_ID &&
                    ev.qualifier.find((item) => item.qualifierId === 28) !==
                      undefined))
            );
            if (e.periodId === 2) {
              optaGraphics.push({
                name:
                  e?.timeMin?.toString()?.padStart(2, "0") +
                  ":" +
                  e.timeSec?.toString()?.padStart(2, "0") +
                  " " +
                  game?.home_team?.code +
                  " " +
                  home_score_ft?.length +
                  " - " +
                  game?.away_team?.code +
                  " " +
                  away_score_ft?.length +
                  " - FT Score Update",
                graphic: graphics?.find((g) => g.name === "Score"),
                options: {
                  type: "FT",
                  game: {
                    ...game,
                    home_scorers: filteredEvents?.filter(
                      (ev) =>
                        e.periodId >= ev.periodId &&
                        ev?.typeId === 16 &&
                        ((ev?.contestantId === game?.home_team?.opta_ID &&
                          ev.qualifier.find(
                            (item) => item.qualifierId === 28
                          ) === undefined) ||
                          (ev?.contestantId === game?.away_team?.opta_ID &&
                            ev.qualifier.find(
                              (item) => item.qualifierId === 28
                            ) !== undefined))
                    ),
                    away_scorers: filteredEvents?.filter(
                      (ev) =>
                        e.periodId >= ev.periodId &&
                        ev?.typeId === 16 &&
                        ((ev?.contestantId === game?.away_team?.opta_ID &&
                          ev.qualifier.find(
                            (item) => item.qualifierId === 28
                          ) === undefined) ||
                          (ev?.contestantId === game?.home_team?.opta_ID &&
                            ev.qualifier.find(
                              (item) => item.qualifierId === 28
                            ) !== undefined))
                    ),
                  },
                  optaEvents: filteredEvents?.filter(
                    (ev) => e.periodId >= ev.periodId && ev?.typeId === 16
                  ),
                },
              });
            }
            optaGraphics.push({
              name:
                e.periodId === 1
                  ? "HT Stats - " +
                    filteredEvents?.filter(
                      (ev) =>
                        ev?.periodId === 1 &&
                        ev?.typeId === 16 &&
                        ((ev?.contestantId === game?.home_team?.opta_ID &&
                          ev.qualifier.find(
                            (item) => item.qualifierId === 28
                          ) === undefined) ||
                          (ev?.contestantId === game?.away_team?.opta_ID &&
                            ev.qualifier.find(
                              (item) => item.qualifierId === 28
                            ) !== undefined))
                    )?.length +
                    " - " +
                    filteredEvents?.filter(
                      (ev) =>
                        ev?.periodId === 1 &&
                        ev?.typeId === 16 &&
                        ((ev?.contestantId === game?.away_team?.opta_ID &&
                          ev.qualifier.find(
                            (item) => item.qualifierId === 28
                          ) === undefined) ||
                          (ev?.contestantId === game?.home_team?.opta_ID &&
                            ev.qualifier.find(
                              (item) => item.qualifierId === 28
                            ) !== undefined))
                    )?.length
                  : e.periodId === 2
                  ? "FT Stats - " +
                    filteredEvents?.filter(
                      (ev) =>
                        ev?.periodId < 5 &&
                        ev?.typeId === 16 &&
                        ((ev?.contestantId === game?.home_team?.opta_ID &&
                          ev.qualifier.find(
                            (item) => item.qualifierId === 28
                          ) === undefined) ||
                          (ev?.contestantId === game?.away_team?.opta_ID &&
                            ev.qualifier.find(
                              (item) => item.qualifierId === 28
                            ) !== undefined))
                    )?.length +
                    " - " +
                    filteredEvents?.filter(
                      (ev) =>
                        ev?.periodId < 5 &&
                        ev?.typeId === 16 &&
                        ((ev?.contestantId === game?.away_team?.opta_ID &&
                          ev.qualifier.find(
                            (item) => item.qualifierId === 28
                          ) === undefined) ||
                          (ev?.contestantId === game?.home_team?.opta_ID &&
                            ev.qualifier.find(
                              (item) => item.qualifierId === 28
                            ) !== undefined))
                    )?.length
                  : "",
              graphic: graphics?.find((g) => g.name === "FFStats"),
              options: {
                game: {
                  ...game,
                  home_scorers: filteredEvents?.filter(
                    (ev) =>
                      ev?.periodId <= e.periodId &&
                      ev?.typeId === 16 &&
                      ((ev?.contestantId === game?.home_team?.opta_ID &&
                        ev.qualifier.find((item) => item.qualifierId === 28) ===
                          undefined) ||
                        (ev?.contestantId === game?.away_team?.opta_ID &&
                          ev.qualifier.find(
                            (item) => item.qualifierId === 28
                          ) !== undefined))
                  ),
                  away_scorers: filteredEvents?.filter(
                    (ev) =>
                      ev?.periodId <= e.periodId &&
                      ev?.typeId === 16 &&
                      ((ev?.contestantId === game?.away_team?.opta_ID &&
                        ev.qualifier.find((item) => item.qualifierId === 28) ===
                          undefined) ||
                        (ev?.contestantId === game?.home_team?.opta_ID &&
                          ev.qualifier.find(
                            (item) => item.qualifierId === 28
                          ) !== undefined))
                  ),
                },
                half: e.periodId,
              },
            });
            break;
          default:
        }
      }

      setOPTAEventGraphics(optaGraphics);
    }
  }, [optaEvents, graphics]);
  return (
    <div>
      <Row>
        <GameList>
          <DateRow>
            <DateButton
              onClick={() => {
                let new_date = moment(date).subtract(1, "days");
                setDate(new_date.format("YYYY-MM-DD"));
              }}
            >
              {"<"}
            </DateButton>
            {date}
            <DateButton
              onClick={() => {
                let new_date = moment(date).add(1, "days");
                setDate(new_date.format("YYYY-MM-DD"));
              }}
            >
              {">"}
            </DateButton>
          </DateRow>
          {fixtures?.map((game, index) => {
            return (
              <>
                {(index === 0 ||
                  game?.competition?._id !==
                    fixtures?.[index - 1]?.competition?._id) && (
                  <FolderItem
                    key={index}
                    level={0}
                    resource={{
                      _id: game?.competition?._id,
                      name: game?.competition?.name,
                    }}
                    onClick={(e, item) => {
                      setSelectedCompetition(game?.competition);
                      setSelectedGame();
                      setSelectedView("PreGame");
                    }}
                  />
                )}
                {game?.competition?._id === selectedCompetition?._id && (
                  <FolderItem
                    key={index}
                    level={1}
                    resource={{ _id: game?._id, name: game?.description }}
                    onClick={(e, item) => {
                      setSelectedGame(game);
                      setSelectedView("PreGame");
                    }}
                  />
                )}
                {game?.competition?._id === selectedCompetition?._id &&
                  game?._id === selectedGame?._id && (
                    <>
                      <FolderItem
                        key={index}
                        level={2}
                        resource={{
                          _id: game?._id + "_" + "PreGame",
                          name: "Pre Game",
                        }}
                        onClick={(e, item) => {
                          setSelectedView("PreGame");
                        }}
                      />
                      <FolderItem
                        key={index}
                        level={2}
                        resource={{
                          _id: game?._id + "_" + "InGame",
                          name: "In Game",
                        }}
                        onClick={(e, item) => {
                          setSelectedView("InGame");
                        }}
                      />
                      <FolderItem
                        key={index}
                        level={2}
                        resource={{
                          _id: game?._id + "_" + "PostGame",
                          name: "Post Game",
                        }}
                        onClick={(e, item) => {
                          setSelectedView("PostGame");
                        }}
                      />
                      <FolderItem
                        key={index}
                        level={2}
                        resource={{
                          _id: game?._id + "_" + "Names",
                          name: "Names",
                        }}
                        onClick={(e, item) => {
                          setSelectedView("Names");
                        }}
                      />
                    </>
                  )}
              </>
            );
          })}
        </GameList>

        <Content>
          {game && (
            <div>
              <TableHeader>
                <PageNameDiv>Graphic</PageNameDiv>
              </TableHeader>

              <TableBody>
                {[]
                  ?.concat(
                    (selectedView === "InGame" && [
                      {
                        name:
                          "00:00" +
                          " " +
                          game?.home_team?.code +
                          " 0 - 0 " +
                          " - Clock",
                        graphic: graphics?.find((g) => g.name === "CLOCK"),
                        options: {
                          game: {
                            ...game,
                            home_scorers: [],
                            away_scorers: [],
                          },
                        },
                      },
                    ]) ||
                      []
                  )
                  ?.concat(
                    (selectedView === "InGame" && [
                      {
                        name:
                          game?.home_team?.code +
                          " 0 - 0 " +
                          " - Penalty Clock",
                        graphic: graphics?.find((g) => g.name === "Penalties"),
                        options: {
                          game: {
                            ...game,
                            home_scorers: [],
                            away_scorers: [],
                          },
                        },
                      },
                      {
                        name:
                          game?.home_team?.code +
                          " " +
                          0 +
                          " - " +
                          game?.away_team?.code +
                          " " +
                          0 +
                          " - FT Score Update",
                        graphic: graphics?.find((g) => g.name === "Score"),
                        options: {
                          type: "FT",
                          game: {
                            ...game,
                            home_scorers: [],
                            away_scorers: [],
                          },
                          optaEvents: [],
                        },
                      },
                    ]) ||
                      []
                  )
                  ?.concat(
                    (selectedView === "InGame" && optaEventGraphics) || []
                  )
                  ?.concat(
                    (selectedView === "PreGame" && [
                      {
                        name: "Match ID",
                        graphic: graphics?.find((g) => g.name === "MatchID"),
                        options: { game },
                      },
                      {
                        name: "Versus",
                        graphic: graphics?.find((g) => g.name === "Versus"),
                        options: { game, period: { number: 1 } },
                      },
                      {
                        name: "Attendance",
                        graphic: graphics?.find((g) => g.name === "Attendance"),
                        options: {
                          game,
                          attendance: optaEvents
                            ?.find((ev) => ev?.typeId === 24)
                            ?.qualifier?.find((q) => q?.qualifierId === 49)
                            ?.value,
                        },
                      },
                      {
                        name: "Commentators",
                        graphic: graphics?.find(
                          (g) => g.name === "Commentators"
                        ),
                        options: { game },
                      },
                      {
                        name:
                          "Referee - " +
                          game?.officials?.find((o) => o?.type === "Main")
                            ?.official?.first_name +
                          " " +
                          game?.officials?.find((o) => o?.type === "Main")
                            ?.official?.last_name,
                        graphic: graphics?.find((g) => g.name === "Referee"),
                        options: {
                          game,
                          player: game?.officials?.find(
                            (o) => o?.type === "Main"
                          )?.official,
                          subtext: game?.officials
                            ?.find((o) => o?.type === "Main")
                            ?.type.replace("Main", "Referee")
                            ?.replace("Lineman 1", "Assistant Referee")
                            ?.replace("Lineman 2", "Assistant Referee"),
                        },
                      },
                      {
                        name: game?.home_team?.name + " Formation",
                        graphic: graphics?.find((g) => g.name === "Formation"),
                        options: {
                          game,
                          team: game?.home_team,
                          formation: game.home_formation,
                          squads: game.lineup?.home,
                          manager: homeManager,
                        },
                      },
                      {
                        name: game?.home_team?.name + " Lineup",
                        graphic: graphics?.find((g) => g.name === "Lineup"),
                        options: {
                          game,
                          team: game?.home_team,
                          formation: game.home_formation,
                          squads: game.lineup?.home,
                          manager: homeManager,
                        },
                      },
                      {
                        name: game?.away_team?.name + " Formation",
                        graphic: graphics?.find((g) => g.name === "Formation"),
                        options: {
                          game,
                          team: game?.away_team,
                          formation: game.away_formation,
                          squads: game.lineup?.away,
                          manager: awayManager,
                        },
                      },
                      {
                        name: game?.away_team?.name + " Lineup",
                        graphic: graphics?.find((g) => g.name === "Lineup"),
                        options: {
                          game,
                          team: game?.away_team,
                          formation: game.away_formation,
                          squads: game.lineup?.away,
                          manager: awayManager,
                        },
                      },
                    ]) ||
                      []
                  )
                  ?.concat(
                    (selectedView === "Names" &&
                      game?.lineup?.home?.map((player) => {
                        return {
                          name:
                            game?.home_team?.code +
                            " - " +
                            (player?.squad?.shirt_number ??
                              player?.squad?.opta_shirt_number) +
                            " - " +
                            (player?.squad?.player?.first_name ??
                              player?.squad?.player?.opta_first_name) +
                            " " +
                            (player?.squad?.player?.last_name ??
                              player?.squad?.player?.opta_last_name),
                          graphic: graphics?.find((g) => g.name === "Name"),
                          options: {
                            game,
                            player: {
                              ...player?.squad,
                              ...player?.squad?.player,
                            },
                            team: game?.home_team,
                          },
                        };
                      })) ||
                      []
                  )
                  ?.concat(
                    (selectedView === "Names" && [
                      {
                        name:
                          game?.home_team?.code +
                          " - " +
                          homeManager?.player?.title +
                          " - " +
                          (homeManager?.player?.first_name ??
                            homeManager?.player?.opta_first_name) +
                          " " +
                          (homeManager?.player?.last_name ??
                            homeManager?.player?.opta_last_name),
                        graphic: graphics?.find((g) => g.name === "Name"),
                        options: {
                          game,
                          player: {
                            ...homeManager,
                            ...homeManager?.player,
                          },
                          team: game?.home_team,
                        },
                      },
                    ]) ||
                      []
                  )
                  ?.concat(
                    (selectedView === "Names" &&
                      game?.lineup?.away?.map((player) => {
                        return {
                          name:
                            game?.away_team?.code +
                            " - " +
                            (player?.squad?.shirt_number ??
                              player?.squad?.opta_shirt_number) +
                            " - " +
                            (player?.squad?.player?.first_name ??
                              player?.squad?.player?.opta_first_name) +
                            " " +
                            (player?.squad?.player?.last_name ??
                              player?.squad?.player?.opta_last_name),
                          graphic: graphics?.find((g) => g.name === "Name"),
                          options: {
                            game,
                            player: {
                              ...player?.squad,
                              ...player?.squad?.player,
                            },
                            team: game?.away_team,
                          },
                        };
                      })) ||
                      []
                  )
                  ?.concat(
                    (selectedView === "Names" && [
                      {
                        name:
                          game?.away_team?.code +
                          " - " +
                          awayManager?.player?.title +
                          " - " +
                          (awayManager?.player?.first_name ??
                            awayManager?.player?.opta_first_name) +
                          " " +
                          (awayManager?.player?.last_name ??
                            awayManager?.player?.opta_last_name),
                        graphic: graphics?.find((g) => g.name === "Name"),
                        options: {
                          game,
                          player: {
                            ...awayManager,
                            ...awayManager?.player,
                          },
                          team: game?.away_team,
                        },
                      },
                    ]) ||
                      []
                  )
                  .concat(
                    (selectedView === "PostGame" && [
                      {
                        name: "Standings",
                        graphic: graphics?.find((g) => g.name === "Standings"),
                        options: { game, standings },
                      },
                      {
                        name: "Fixtures mon-sun",
                        graphic: graphics?.find((g) => g.name === "Fixtures"),
                        options: { game, fixtures: fixturesData },
                      },
                    ]) ||
                      []
                  )
                  ?.map((graphic) => {
                    let available =
                      scenes?.findIndex(
                        (s) =>
                          s.data?.football?.templates?.findIndex(
                            (t) =>
                              t?.name ===
                                graphic?.graphics?.getName({
                                  options: graphic?.options,
                                }) || graphic.graphic?.scene
                          ) > -1
                      ) > -1;
                    return (
                      <TableRow
                        available={available ? 1 : 0}
                        onClick={() => {}}
                        onDoubleClick={() => {
                          graphic.graphic?.preview({
                            description:
                              game?.home_team?.code +
                              " v " +
                              game?.away_team?.code +
                              " " +
                              graphic?.name,
                            options: graphic?.options,
                          });
                        }}
                        onContextMenu={(e) => {
                          // handleContextMenu(e, page);
                        }}
                      >
                        <div>
                          {graphic?.name}{" "}
                          {available === false && "- No graphic mapped"}
                        </div>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </div>
          )}
        </Content>
      </Row>
    </div>
  );
}

const Main = styled.div`
  padding-left: 1em;
  padding-top: 1em;
  cursor: pointer;
  padding-top: 0.3em;
  padding-bottom: 0.3em;
  font-size: 0.8em;
  background-color: ${(props) => (props.altColour ? "#1c222b" : "")};
  :hover {
    background-color: #d11e42;
  }
`;

function Graphic() {
  return <Main>Match ID</Main>;
}
export default FootballData;
